import { businessImpactData } from "@/mocks/homeData";
import AnimatedSection from "@/components/AnimatedSection";

export default function BusinessImpactSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100 relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-accent-500/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-secondary-500/5 rounded-full blur-3xl" />

      <div className="container-astro relative z-10">
        <AnimatedSection>
          <div className="text-center mb-14 md:mb-18">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 mb-5 font-heading tracking-tight">
              {businessImpactData.heading}
            </h2>
            <div className="w-16 h-1 rounded-full mx-auto bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316]" />
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {businessImpactData.items.map((item, i) => (
            <AnimatedSection key={item.number} delay={i * 120}>
              <div className="group p-7 md:p-8 rounded-2xl bg-background-50 border border-background-200/60 hover:border-accent-300/30 hover:shadow-lg hover:shadow-accent-500/5 transition-all duration-400 card-lift h-full">
                {/* Gradient number */}
                <div
                  className={`w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br ${item.gradient} mb-5`}
                >
                  <span className="text-lg font-extrabold text-white font-heading">
                    {item.number}
                  </span>
                </div>

                {/* Icon */}
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                </div>

                <h3 className="text-lg font-bold text-foreground-950 mb-2.5 font-heading">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}